import React from 'react'
import { connect }  from 'react-redux';
import { removeMsg  } from '../../../redux/actions/msg-actions'; 
import CloseImg from '../../../assets/images/close.svg';
import Modal from './Modal';
import s from './Msgs.scss';


const modalStyle = {
    backgroundColor: 'rgb(0,157,255)',
    color: 'white',
    fontWeight: 600,
    borderRadius: '8px',
    fontSize: '15px',
}

const Msg = ({ msg, removeMsg }) => {
    if (msg.type === 'modal') {
        return (
            <Modal width="450px" style={modalStyle} backgroundColor="rgba(255, 255, 255, 0.5)" showModal closeImgWhite closeOnBlur closeModal={() => removeMsg(msg.id)}>
                <div>
                    {msg.text}
                    <button onClick={() => removeMsg(msg.id)} className="btn btn-alt btn-small">Cerrar</button>
                </div>
            </Modal>
        );
    } else if (msg.type === 'msg') {
        return (
            <div className={s.alert}>
            <span
                className={s.close}
                onClick={() => removeMsg(msg.id)}
              >
                <img src={CloseImg} alt="Cerrar" />
              </span>
                {msg.text}
            </div>
        );
    }

}

const Msgs = ({ msgs, removeMsg }) => (
    <div className={s.alertContainer}> 
        {msgs.map(msg => <Msg key={msg.id} msg={msg} removeMsg={removeMsg} />)}
    </div>
);


const mapStateToProps = ({ msgs }) => ({ msgs });

const mapDispatchToProps = dispatch => ({
    removeMsg: id => dispatch(removeMsg(id)) 
})

export default connect(mapStateToProps, mapDispatchToProps)(Msgs)